import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toastr } from "react-redux-toastr";
import { API_DARTS_EVENT_MANAGER_HEADER, API_DARTS_EVENT_MANAGER_GAME, STATISTICS_INIT } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { DartsState, IDartsInitData, DartsGame } from "./DartsEventManager.types";
import { DartsPlayerType } from "../../../pages/Darts/Players/DartsPlayersCRUD.types";
import { IdName } from "../../../common/types/IdName";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";

const initialState: DartsState = {
    groups: [] as IdName[],
    groupSelected: 0,
    tournaments: [] as IdName[],
    tournamentSelected: 0,
    selectedGame: 0,
    selectedAdcGame: 0,
    players: [] as DartsPlayerType[],
    countries: [] as IdName[],
    isLoading: false,
    downloadedItems: 0,
    totalItemsForDownloading: 0,
    keyForDownloading:"",
    statsInitOptions:[],
    scheduleGames:[]
}

interface IGetStatsInitResponse {
    players: IdName[]
}

export interface GameStatsInfo {
    count: number,
    key: string
}

export const getDartsEventManagerHeader = createAsyncThunk<IDartsInitData, void, { rejectValue: string }>(API_DARTS_EVENT_MANAGER_HEADER,
    async (_, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_EVENT_MANAGER_HEADER}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Failed get schedule data");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
);

export const getScheduleGames = createAsyncThunk<DartsGame[], string, { rejectValue: string }>(API_DARTS_EVENT_MANAGER_GAME,
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_EVENT_MANAGER_GAME}${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Failed get schedule data");
            return rejectWithValue(result.error);
        }
        return result.data;
    }
);

export const getStatisticsInit = createAsyncThunk<IGetStatsInitResponse, void, { rejectValue: string }>(STATISTICS_INIT,
    async (filterPayload, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(STATISTICS_INIT).then(res => res.data)
        );
        if (!result.success) {
            return rejectWithValue(result.error);
        }
        return result.data;
    }
);

export const DartsEventManagerSlice = createSlice({
    name: 'scheduleSlice',
    reducers: {
        setDartsInitData: (state, action: PayloadAction<IDartsInitData>) => {
            state.tournaments = action.payload.tournaments
            state.groups = action.payload.groups
            state.tournamentSelected = action.payload.tournaments.length > 0 ? action.payload.tournaments[0].id : -1
            state.groupSelected = action.payload.groups.length > 0 ? action.payload.groups[0].id : -1
        },
        selectClassicGame: (state, action: PayloadAction<number>) => {
            state.selectedGame = action.payload
        },
        selectAdcGame: (state, action: PayloadAction<number>) => {
            state.selectedAdcGame = action.payload
        },
        selectTournament: (state, action: PayloadAction<number>) => {
            state.tournamentSelected = action.payload
        },
        selectGroup: (state, action: PayloadAction<number>) => {
            state.groupSelected = action.payload
        },
        deleteActiveGameAndTournament: (state) => {
            state.tournamentSelected = 0;
            state.selectedGame = 0;
            state.selectedAdcGame = 0;
        },
        setTotalItemsForDownloading: (state, action:PayloadAction<GameStatsInfo>) => {
            state.totalItemsForDownloading = action.payload.count
            state.keyForDownloading = action.payload.key
        },
        setDownloadedItems: (state, action: PayloadAction<number>) => {
            state.downloadedItems = action.payload;
        },
        setCsvStatisticsFinished: (state) => {
            state.downloadedItems = state.totalItemsForDownloading
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getDartsEventManagerHeader.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDartsEventManagerHeader.fulfilled, (state, action) => {
                state.tournaments = action.payload.tournaments
                state.groups = action.payload.groups
                state.tournamentSelected = action.payload.tournaments.length > 0 ? action.payload.tournaments[0].id : -1
                state.groupSelected = action.payload.groups.length > 0 ? action.payload.groups[0].id : -1
                state.isLoading = false;
            })
            .addCase(getDartsEventManagerHeader.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getStatisticsInit.fulfilled, (state, action) => {
                state.statsInitOptions = action.payload.players
            })
            .addCase(getScheduleGames.fulfilled,(state,action)=>{
                state.scheduleGames = action.payload
            })
    }
})
export const {
    //setDartsInitData,
    selectClassicGame,
    selectAdcGame,
    selectTournament, selectGroup,
    deleteActiveGameAndTournament,
    setDownloadedItems,
    setCsvStatisticsFinished,
    setTotalItemsForDownloading
} = DartsEventManagerSlice.actions;

export default DartsEventManagerSlice.reducer;
